import update from 'immutability-helper';

import {
  SET_FILES_LOADING,
  SET_FILES_END,
  GET_FILES,
  SET_FILES_TOTAL,
  SET_FILES_ARCHIVED,
  CLEAR_FILES,
  CLEAR_FILES_LIST,
  SET_FILES_PARAMS,
  CLEAR_FILES_PARAMS,
  SET_FILES_FILTERS,
  SET_COLLECTION_UUID,
  CLEAR_FILES_FILTERS,
  SET_SELECTED_FILES,
  ADD_SELECTED_FILE,
  ADD_SELECTED_FILES,
  REMOVE_SELECTED_FILE,
  CLEAR_SELECTED_FILES,
  SET_FILES_SEARCH_TYPE,
  SHOW_UPLOAD_MODAL,
  HIDE_UPLOAD_MODAL,
  SET_UPLOAD_MODAL_MODE,
  SELECT_FILE,
  UPDATE_FILE_FRAGMENT,
  ADD_FILE_TO_FILES_LIST,
  UPDATE_FILES_ON_FILES_LIST,
  UPDATE_FILES_LIKES_ON_FILES_LIST,
  UPDATE_FILES_ON_SELECTED_FILES_LIST,
  REMOVE_FILES_FROM_FILES_LIST,
  REMOVE_FILES_FROM_SELECTED_FILES_LIST,
  UPDATE_LAST_FILES_UPDATE_TIME,
  GET_AVAILABLE_FILTERS,
  GET_FILE_STATUSES,
  ADD_SELECTED_FILTER,
  SET_SELECTED_FILTERS,
  REMOVE_SELECTED_FILTER,
  CLEAR_SELECTED_FILTERS,
  SET_SELECTED_ALL_FILES,
  ADD_DOWNLOAD_REQUEST,
  REMOVE_DOWNLOAD_REQUEST,
  SWAP_FILES,
  SET_FILES_REORDERING_MODE,
  GET_FILE_COMMENTS,
  SET_FILE_COMMENTS_LOADING,
  SET_FILE_COMMENTS_VIEW,
  SET_FILE_COMMENTS_ORDER,
  SET_FILE_COMMENT_HIGHLIGHTED,
  SET_FILE_COMMENTS_ANNOTATE_MODE,
  SET_FILE_SUBSCRIPTION,
  SET_FILE_MODAL_OPEN,
  SET_FILES_GROUP_UUID,
  SET_FILES_GROUP_LOADING,
  SET_FILE_EDITIONS,
  SET_FILE_EDITIONS_LOADING,
  REMOVE_FILE_EDITION,
  GET_FILES_GROUP,
  CLEAR_FILES_GROUP,
  SET_DOWNLOAD_UUID,
  SET_DOWNLOAD_LOADING,
  GET_DOWNLOAD,
  CLEAR_DOWNLOAD,
} from '../actions/Files';

import { cleanupObject } from '../api';

const initialFilesParams = {
  page: 0,
  perPage: 36,
  orderby: 'position',
  order: 'asc',
  archived: false,
  noFilters: false,
};

export const initialFilesFilters = {
  terms: [],
  statuses: [],
  types: [],
  extensions: [],
  visibility: [],
  user_ids: [],
  deleted_by: [],
  people: [],
  collection_groups: [],
  collections: [],
  orientation: [],
  no_collections: null,
  date: null,
  date_from: null,
  date_to: null,
  original_date: null,
  original_date_from: null,
  original_date_to: null,
  expiration_date: null,
  expiration_date_from: null,
  expiration_date_to: null,
};

const initialState = {
  files: [],
  filesTotal: 0,
  filesArchived: 0,
  params: { ...initialFilesParams },
  filters: { ...initialFilesFilters },
  availableFilters: {
    terms: [],
    statuses: [],
    types: [],
    extensions: [],
    visibility: [],
    user_ids: [],
    deleted_by: [],
    people: [],
    orientation: [],
    collection_groups: [],
    collections: [],
    no_collections: null,
    min_created_at: null,
    min_original_datetime: null,
    min_expiration_datetime: null,
  },
  selectedFilters: [],
  searchType: 'new',
  statuses: [],
  collectionUuid: null,
  selectedFile: null,
  selectedFiles: [],
  selectedAllFiles: false,
  loading: false,
  end: false,
  uploadModal: false,
  uploadModalMode: 'upload',
  downloadRequests: [],
  reorderingMode: false,
  comments: [],
  commentsSubscribed: false,
  commentsLoading: false,
  commentsView: 'all',
  commentsOrder: null,
  commentHighlighted: null,
  commentsAnnotateMode: false,
  fileModalOpen: false,
  filesGroupUuid: null,
  filesGroup: null,
  filesGroupLoading: false,
  fileEditions: [],
  fileEditionsLoading: false,
  downloadUuid: null,
  download: null,
  downloadLoading: false,
  lastUpdate: new Date().toISOString(),
};

const fileAttributesToRemove = [
  'user',
  'urls',
  'attributes',
  'versions',
  'likes',
  'featured_file',
  'people',
];

const fileAttributesKeysPreserve = {
  attributes: ['prefix', 'suffix'],
};

const miniFileAttributesToRemove = [
  'user',
  'attributes',
  'versions',
  'likes',
  'featured_file',
  'status',
  'people',
];

const miniFileAttributesKeysPreserve = {
  attributes: ['prefix', 'suffix', 'width', 'height'],
};

export const Files = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILES_LOADING:
      return Object.assign({}, state, {
        loading: action.loading,
      });

    case SET_FILES_END:
      return Object.assign({}, state, {
        end: action.end,
      });

    case GET_FILES:
      return Object.assign({}, state, {
        files: action.files === null ? [] : state.files.concat(action.files),
      });

    case SET_FILES_TOTAL:
      return Object.assign({}, state, {
        filesTotal: action.total,
      });

    case SET_FILES_ARCHIVED:
      return Object.assign({}, state, {
        filesArchived: action.archived,
      });

    case CLEAR_FILES:
      return Object.assign({}, state, {
        files: [],
        filesTotal: 0,
        params: {
          ...initialFilesParams,
          orderby: (action.hasSearch && state.params.orderby === 'relevance') ?
            initialFilesParams.orderby : state.params.orderby,
          order: (action.hasSearch && state.params.orderby === 'relevance') ?
            initialFilesParams.order : state.params.order,
        },
        selected: [],
        end: false,
      });

    case CLEAR_FILES_LIST: {
      return Object.assign({}, state, {
        files: [],
        filesTotal: 0,
        params: { ...state.params, page: 0 },
        selected: [],
        end: false,
      });
    }

    case CLEAR_FILES_PARAMS:
      return Object.assign({}, state, {
        params: { ...initialFilesParams },
      });

    case SET_FILES_PARAMS:
      return Object.assign({}, state, {
        params: Object.assign({}, state.params, action.params),
      });

    case SET_FILES_FILTERS:
      return Object.assign({}, state, {
        filters: Object.assign({}, state.filters, action.filters),
      });

    case CLEAR_FILES_FILTERS:
      return Object.assign({}, state, {
        filters: {
          terms: [],
          statuses: [],
          types: [],
          extensions: [],
          visibility: [],
          user_ids: [],
          deleted_by: [],
          people: [],
          collection_groups: [],
          collections: [],
          no_collections: null,
          date: null,
          date_from: null,
          date_to: null,
        },
      });

    case SET_COLLECTION_UUID:
      return Object.assign({}, state, {
        collectionUuid: action.collectionUuid,
      });

    case SET_SELECTED_FILES:
      return Object.assign({}, state, {
        selectedFiles: action.files.map(f => (
          cleanupObject(f, fileAttributesToRemove, fileAttributesKeysPreserve)
        )),
      });

    case ADD_SELECTED_FILE:
      return Object.assign({}, state, {
        selectedFiles: window._.uniqBy(state.selectedFiles.concat([
          cleanupObject(
            action.file,
            action.isMini ? miniFileAttributesToRemove : fileAttributesToRemove,
            action.isMini ? miniFileAttributesKeysPreserve : fileAttributesKeysPreserve,
          ),
        ]), 'uuid'),
      });

    case ADD_SELECTED_FILES:
      return Object.assign({}, state, {
        selectedFiles: window._.uniqBy(state.selectedFiles.concat(action.files.map(f => (
          cleanupObject(
            f,
            action.isMini ? miniFileAttributesToRemove : fileAttributesToRemove,
            action.isMini ? miniFileAttributesKeysPreserve : fileAttributesKeysPreserve,
          )
        ))), 'uuid'),
      });

    case REMOVE_SELECTED_FILE:
      return Object.assign({}, state, {
        selectedFiles: state.selectedFiles.filter(f => (f.uuid !== action.fileUuid)),
        selectedAllFiles: false,
      });

    case CLEAR_SELECTED_FILES:
      return Object.assign({}, state, {
        selectedFiles: [],
      });

    case SET_SELECTED_ALL_FILES:
      return Object.assign({}, state, {
        selectedAllFiles: action.allFilesSelected,
      });

    case SHOW_UPLOAD_MODAL:
      return Object.assign({}, state, {
        uploadModal: true,
      });

    case HIDE_UPLOAD_MODAL:
      return Object.assign({}, state, {
        uploadModal: false,
      });

    case SET_UPLOAD_MODAL_MODE:
      return Object.assign({}, state, {
        uploadModalMode: action.mode,
      });

    case SELECT_FILE:
      return Object.assign({}, state, {
        selectedFile: action.file,
      });

    case ADD_FILE_TO_FILES_LIST: {
      const newFilesTotal = state.filesTotal + 1;
      let newFiles = state.files.slice(0);
      const index = newFiles.findIndex(file => file.uuid === action.targetFileUuid);
      if (index >= 0) {
        newFiles = [
          ...newFiles.slice(0, index),
          action.file,
          ...newFiles.slice(index),
        ];
      }
      return Object.assign({}, state, {
        files: newFiles,
        filesTotal: newFilesTotal,
        lastUpdate: new Date().toISOString(),
      });
    }

    case UPDATE_FILES_ON_FILES_LIST: {
      const newFiles = state.files.slice(0);
      action.files.forEach((file) => {
        const fileIndex = newFiles.findIndex(f => (f.uuid === file.uuid));
        if (fileIndex > -1) {
          newFiles.splice(fileIndex, 1, file);
        }
      });
      return Object.assign({}, state, {
        files: newFiles,
      });
    }

    case UPDATE_FILE_FRAGMENT: {
      const newFiles = state.files.slice(0);
      const fileIndex = newFiles.findIndex(f => (f.uuid === action.fragment.uuid));
      if (fileIndex > -1) {
        newFiles[fileIndex] = {
          ...newFiles[fileIndex],
          ...action.fragment,
        };
      }
      return Object.assign({}, state, {
        files: newFiles,
      });
    }

    case UPDATE_FILES_LIKES_ON_FILES_LIST: {
      const newFiles = state.files.slice(0);
      action.files.forEach((file) => {
        const fileIndex = newFiles.findIndex(f => (f.uuid === file.uuid));
        if (fileIndex > -1) {
          newFiles[fileIndex].likes = file.likes;
          newFiles[fileIndex].likes_count = file.likes_count;
          newFiles[fileIndex].liked = file.liked;
        }
      });
      return Object.assign({}, state, {
        files: newFiles,
      });
    }

    case UPDATE_FILES_ON_SELECTED_FILES_LIST: {
      const newFiles = state.selectedFiles.slice(0);
      action.files.forEach((file) => {
        const fileIndex = newFiles.findIndex(f => (f.uuid === file.uuid));
        if (fileIndex > -1) {
          newFiles[fileIndex] = file;
        }
      });
      return Object.assign({}, state, {
        selectedFiles: newFiles,
      });
    }

    case REMOVE_FILES_FROM_FILES_LIST: {
      let newFiles = state.files.slice(0);
      action.files.forEach((file) => {
        newFiles = newFiles.filter(nf => (nf.uuid !== file.uuid));
      });
      return Object.assign({}, state, {
        files: newFiles,
        lastUpdate: new Date().toISOString(),
      });
    }

    case REMOVE_FILES_FROM_SELECTED_FILES_LIST: {
      let newFiles = state.selectedFiles.slice(0);
      action.files.forEach((file) => {
        newFiles = newFiles.filter(nf => (nf.uuid !== file.uuid));
      });
      return Object.assign({}, state, {
        selectedFiles: newFiles,
      });
    }

    case UPDATE_LAST_FILES_UPDATE_TIME:
      return Object.assign({}, state, {
        lastUpdate: new Date().toISOString(),
      });

    case GET_AVAILABLE_FILTERS:
      return Object.assign({}, state, {
        availableFilters: Object.assign({}, initialState.availableFilters, action.filters),
      });

    case GET_FILE_STATUSES:
      return Object.assign({}, state, {
        statuses: action.statuses,
      });

    case ADD_SELECTED_FILTER:
      return Object.assign({}, state, {
        selectedFilters: state.selectedFilters.concat([action.filter]),
      });

    case SET_SELECTED_FILTERS:
      return Object.assign({}, state, {
        selectedFilters: action.filters,
      });

    case REMOVE_SELECTED_FILTER: {
      if (action.filterKey) {
        return Object.assign({}, state, {
          selectedFilters: state.selectedFilters
            .filter(f => (!(`${f.key}` === `${action.filterKey}` && f.type === action.filterType))),
        });
      }
      return Object.assign({}, state, {
        selectedFilters: state.selectedFilters
          .filter(f => (f.type !== action.filterType)),
      });
    }

    case CLEAR_SELECTED_FILTERS:
      return Object.assign({}, state, {
        selectedFilters: [],
      });

    case SET_FILES_SEARCH_TYPE:
      return Object.assign({}, state, {
        searchType: action.searchType,
      });

    case ADD_DOWNLOAD_REQUEST:
      return Object.assign({}, state, {
        downloadRequests: state.downloadRequests.concat([action.downloadRequest]),
      });

    case REMOVE_DOWNLOAD_REQUEST:
      return Object.assign({}, state, {
        downloadRequests:
          state.downloadRequests.filter(dr => (dr !== action.downloadRequestUuid)),
      });

    case SWAP_FILES: {
      const fi = action.firstItem;
      const si = action.secondItem;
      const { files } = state;

      const fmi = files.findIndex(f => (f.uuid === fi));
      const smi = files.findIndex(f => (f.uuid === si));

      if (fmi >= 0 && smi >= 0) {
        return update(state, {
          files: {
            $splice: [
              [fmi, 1],
              [smi, 0, files[fmi]],
            ],
          },
        });
      }

      return Object.assign({}, state, {
        files,
      });
    }

    case SET_FILES_REORDERING_MODE:
      return Object.assign({}, state, {
        reorderingMode: action.status,
      });

    case GET_FILE_COMMENTS:
      return Object.assign({}, state, {
        comments: action.comments.comments,
        commentsSubscribed: action.comments.subscribed || false,
      });

    case SET_FILE_COMMENTS_VIEW:
      return Object.assign({}, state, {
        commentsView: action.view || 'all',
      });

    case SET_FILE_COMMENTS_ORDER:
      return Object.assign({}, state, {
        commentsOrder: action.order || null,
      });

    case SET_FILE_COMMENT_HIGHLIGHTED:
      return Object.assign({}, state, {
        commentHighlighted: action.commentId || null,
      });

    case SET_FILE_COMMENTS_ANNOTATE_MODE:
      return Object.assign({}, state, {
        commentsAnnotateMode: action.commentsAnnotateMode,
      });

    case SET_FILE_SUBSCRIPTION:
      return Object.assign({}, state, {
        commentsSubscribed: action.status || false,
      });

    case SET_FILE_COMMENTS_LOADING:
      return Object.assign({}, state, {
        commentsLoading: action.loading,
      });

    case SET_FILE_MODAL_OPEN:
      return Object.assign({}, state, {
        fileModalOpen: action.status,
      });

    case SET_FILES_GROUP_UUID:
      return Object.assign({}, state, {
        filesGroupUuid: action.filesGroupUuid,
      });

    case GET_FILES_GROUP:
      return Object.assign({}, state, {
        filesGroup: action.filesGroup,
      });

    case CLEAR_FILES_GROUP:
      return Object.assign({}, state, {
        filesGroup: null,
      });

    case SET_FILES_GROUP_LOADING:
      return Object.assign({}, state, {
        filesGroupLoading: action.loading,
      });

    case SET_FILE_EDITIONS:
      return Object.assign({}, state, {
        fileEditions: action.editions,
      });

    case SET_FILE_EDITIONS_LOADING:
      return Object.assign({}, state, {
        fileEditionsLoading: action.loading,
      });

    case REMOVE_FILE_EDITION:
      return Object.assign({}, state, {
        fileEditions: state.fileEditions.filter(e => (e.uuid !== action.editionUuid)),
      });

    case SET_DOWNLOAD_UUID:
      return Object.assign({}, state, {
        downloadUuid: action.downloadUuid,
      });

    case GET_DOWNLOAD:
      return Object.assign({}, state, {
        download: action.download,
      });

    case CLEAR_DOWNLOAD:
      return Object.assign({}, state, {
        download: null,
      });

    case SET_DOWNLOAD_LOADING:
      return Object.assign({}, state, {
        downloadLoading: action.loading,
      });

    default:
      return state;
  }
};
